import React, { Component } from 'react';
// import moment from 'moment';
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import { FadeLoader } from 'react-spinners';
import moment from 'moment';
import Autocomplete from 'react-autocomplete';
import 'rc-tooltip/assets/bootstrap_white.css';
import _ from 'lodash';
import { IDPROCESO_PCPCP } from '../constants';
import getTipoReprogramacion from '../utils/getTipoReprogramacion';
import TablaProgramados from './tablasEntregas/programados';
import TablaPendientes  from './tablasEntregas/pendientes';
import TablaEntregados from './tablasEntregas/entregados';
import TablaPorProgramar from './tablasEntregas/porProgramar';
import TablaTodos from './tablasEntregas/todos';
import { loadFichasEntrega,
  fetchFichasEntrega,
  fetchFichaEntrega,
  fetchFamilia,
  fetchCompanias,
  fetchMarcasPorFamilia,
  fetchEstadoPedido,
  fetchEstadoGeneralPlanif,
  fetchEstadoCancelacion,
  fetchEstadoGeneralTransp,
  fetchEstadoGeneralTipoPlaca,
  fetchEstadoGeneralTipoEntrega,
  fetchHistorial,
  fetchAreasVenta,
  fetchZonas,
  fetchColaboradores,
  clearColaboradores,
  fetchEstadoGeneralMotivoRechazo,
  fetchIndicadoresEntregas,
  personasAdicionales,
  listarProgramacionXsede,
  fetchVendedores,
  clearVendedores,
  fetchFichasEntregaDescargar,
  programacionCalendario,
  fetchFamiliaPorAreaVta, PAG_0, PAG_1, CANT_X_PAG } from '../actions';
import MainRowSection from '../components/FichaEntrega/MainRowSection';
import KpisSection from '../components/FichaEntrega/KpisSection';
import ModalProgramacion from '../components/FichaEntrega/ModalProgramacion';
import ModalReProgramacion from '../components/FichaEntrega/ModalReprogramacion';
import AprobarRechazarPase from '../components/FichaEntrega/AprobarRechazarPase';
import AnularEntregaProgramada from '../components/FichaEntrega/AnularEntregaProgramada';
import DetalleEntregasLogistica from '../components/FichaEntregasLogistica/DetalleEntregasLogistica.js';
import RechazadoEntregas from '../components/FichaEntrega/RechazadoEntregas.js';
import postEntregasPaseAprogramacion from '../utils/postEntregasPaseAprogramacion';
import postEntregasAnularEntregaProg from '../utils/postEntregasAnularEntregaProg';
import postEntregasHistorial from '../utils/postEntregasHistorial';
import getMotivosEntregas from '../utils/getMotivosEntregas';
import getFiliales from '../utils/getFiliales';
import getReprogramacion from '../utils/getReprogramacion';
import getContactoCliente from '../utils/getContactoCliente';
import getvalidacionPedidos from '../utils/getvalidacionPedidos';

import ComboCheck from '../components/TableActions/comboCheck.js';
import saveAs from '../utils/downloadFile';

const COMBO_CHECK_A_VTA = 'COMBO_CHECK_A_VTA';
const COMBO_CHECK_ZONACOMER = 'COMBO_CHECK_ZONACOMER';
const COMBO_CHECK_FILIAL = 'COMBO_CHECK_FILIAL';
const COMBO_CHECK_COMPANIA = 'COMBO_CHECK_COMPANIA';
const COMBO_CHECK_MARCA = 'COMBO_CHECK_MARCA';
const COMBO_CHECK_FAMILIA = 'COMBO_CHECK_FAMILIA';
const COMBO_CHECK_ESTADOPED = 'COMBO_CHECK_ESTADOPED';
const COMBO_CHECK_ESTADOPLAN = 'COMBO_CHECK_ESTADOPLAN';
const COMBO_CHECK_ESTADOCANCEL = 'COMBO_CHECK_ESTADOCANCEL';
const COMBO_CHECK_TRANSPORTISTA = 'COMBO_CHECK_TRANSPORTISTA';
const COMBO_CHECK_TIPOPLACA = 'COMBO_CHECK_TIPOPLACA';
const COMBO_CHECK_TIPOENTREGA = 'COMBO_CHECK_TIPOENTREGA';
const COMBO_CHECK_FILIAL_VENTA = 'COMBO_CHECK_FILIAL_VENTA';

const ANIO = moment().year();
const MES = moment().month() + 1;
const DIA = moment().date();
const DATE_INICIO = moment(moment(`01/${MES}/${ANIO}`, 'DD/MM/YYYY').subtract(1, 'month')).format('DD/MM/YYYY');
const DATE_FIN = moment(moment(DATE_INICIO, 'DD/MM/YYYY').endOf('month')).format('DD/MM/YYYY');

const DATE_INICIO_LOAD = moment(moment(`${DIA}/${MES}/${ANIO}`, 'DD/MM/YYYY').subtract(1, 'month'));
const DATE_FIN_LOAD = moment(moment(`${DIA}/${MES}/${ANIO}`, 'DD/MM/YYYY').add(1, 'month'));

class FichaEntrega extends Component {
  static handleClick(e) {
    e.currentTarget.parentNode.classList.toggle('open');
  }
  static hideMessage() {
    document.getElementById('alertFichaEntrega').style.display = 'flex';
    setTimeout(() => {
      if (document.getElementById('alertFichaEntrega')) {
        document.getElementById('alertFichaEntrega').style.display = 'none';
      }
    }, 5000);
  }
  constructor(props) {
    super(props);

    this.state = {
      comboSelected: '',
      selectedID: [],
      countTable: 0,
      dataRows: [],
      closeModal: true,
      estado: 'PR',
      muestraModalMasFiltros: 'none',
      startDateInicio: DATE_INICIO_LOAD,
      startDateFinal: DATE_FIN_LOAD,
      searchOption: 'npedido',
      cantidadPaginas: 0,
      totalRegistros: 0,
      nroPag: 0,
      nInicio: 0,
      nFin: 0,
      checkAreaVta: [],
      checkZonaComer: [],
      checkFilial: [],
      checkCompania: [],
      checkMarca: [], //
      checkFamilia: [],
      checkEstadoPed: [],
      checkEstadoPlan: [],
      checkEstadoCancel: [],
      checkTransportista: [],
      checkTipoPlaca: [],
      checkTipoEntrega: [],
      numeroInput: '',
      muestraLoad: 'block',
      searchOptionFechas: 'fcc',
      vendedorId: '',
      nomClienteInput: '',
      modeloInput: '',
      tipoModal: '',
      muestraModalAprobarRechazar: 'none',
      colaboradores: [],
      muestraModalAnularEntregaProgramada: 'none',
      muestraModalVerDetalle: 'none',
      arrayCodigoDetalle: [],
      mensajeAlert: '',
      colorBackground: '#fcbc61',
      iconAlert: 'ion-alert-circled',
      muestraDescargas: 'none',
      dataProgramar: [],
      datafromEntrega: {},
      currentEvent: [],
      entregasLogisticaPR: [],
      entregasLogisticaPP: [],
      entregasLogisticaPE: [],
      entregasLogisticaEN: [],
      disponibilidad: [],
      motivosAnulacion: [],
      motivosHistorial: [],
      filialesXAreaVtaXZona: [],
      reprogramaciones: [],
      muestraModalVerRechazo: 'none',
      contactoCliente:[],
      programacionRow:{},
      respEntrega:'',
      listaMotivoReprogramacion:[],
      LugarEntrega:[],
      checkLugarEntrega: [],
    };

    this.handleOnClickProgramer = this.handleOnClickProgramer.bind(this);
    this.handleChangeModalFrom = this.handleChangeModalFrom.bind(this);
    this.handleChangeModalReFrom = this.handleChangeModalReFrom.bind(this);
    this.onClickOptinTab = this.onClickOptinTab.bind(this);
    this.handleChangeInicio = this.handleChangeInicio.bind(this);
    this.handleChangeFinal = this.handleChangeFinal.bind(this);

    this.initPaginacion = this.initPaginacion.bind(this);
    this.abrirModalAprobarRechazar = this.abrirModalAprobarRechazar.bind(this);
    this.traerColaboradores = this.traerColaboradores.bind(this);
    this.limpiarColaboradores = this.limpiarColaboradores.bind(this);
    this.cerrarModalAprobarRechazar = this.cerrarModalAprobarRechazar.bind(this);
    this.clickAccionAprobarRechazar = this.clickAccionAprobarRechazar.bind(this);
    this.abrirModalAnularEntregaProgramada = this.abrirModalAnularEntregaProgramada.bind(this);
    this.cerrarModalAnularEntregaProgramada = this.cerrarModalAnularEntregaProgramada.bind(this);
    this.clickAnularEntrega = this.clickAnularEntrega.bind(this);
    this.abrirModalVerDetalle = this.abrirModalVerDetalle.bind(this);
    this.cerrarModalVerDetalle = this.cerrarModalVerDetalle.bind(this);
    this.clickComentar = this.clickComentar.bind(this);
    this.handleClearFilter = this.handleClearFilter.bind(this);
    this.handleClickComboCheck = this.handleClickComboCheck.bind(this);
    this.handleInputChangeComboCheck = this.handleInputChangeComboCheck.bind(this);

    this.changeSearchOption = this.changeSearchOption.bind(this);
    this.onChangeNumeroInput = this.onChangeNumeroInput.bind(this);
    this.changeSearchOptionFechas = this.changeSearchOptionFechas.bind(this);
    this.searchFechas = this.searchFechas.bind(this);
    this.handleClickComboCheckFiltrar = this.handleClickComboCheckFiltrar.bind(this);
    this.abrirModalMasFiltros = this.abrirModalMasFiltros.bind(this);
    this.filtrarMas = this.filtrarMas.bind(this);
    this.cerrarModalMasFiltros = this.cerrarModalMasFiltros.bind(this);
    this.cancelarModalMasFiltros = this.cancelarModalMasFiltros.bind(this);
    this.siguiente = this.siguiente.bind(this);
    this.atras = this.atras.bind(this);
    this.clickDescargas = this.clickDescargas.bind(this);
    this.clickDescargarExcel = this.clickDescargarExcel.bind(this);
    this.nombreDelEstadoProgramacion = this.nombreDelEstadoProgramacion.bind(this);
    this.selectFDEntregaAll = this.selectFDEntregaAll.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.abrirModalVerRechazo = this.abrirModalVerRechazo.bind(this);
    this.cerrarModalVerRechazo = this.cerrarModalVerRechazo.bind(this);
    this.closeModalProgramacion = this.closeModalProgramacion.bind(this);
    this.handleOnClickReprogramer = this.handleOnClickReprogramer.bind(this);
  }
  componentDidMount() {

    document.addEventListener('click', this.handleClickComboCheck, true);
    document.addEventListener('keydown', this.onKeyDown, true);
    this.props.loadFichasEntrega();
    this.props.fetchFichasEntrega('PR', PAG_1, CANT_X_PAG, 'npedido', '', 'fcc', DATE_INICIO_LOAD, DATE_FIN_LOAD)
    .then((result) => {
      if (result.payload.data.estadoTrama === '1') {
        getReprogramacion(result.payload.data.entrega.filter(x => x.estaPlan === 'REPROGRAMADO').map(row => row.codPlanEntrVehi)).then((motivos) => {
          this.setState({ reprogramaciones: motivos });
        });

        this.initPaginacion(result.payload.data.totalRegistros,
          result.payload.data.cantidadPaginas);
      } else if (result.payload.data.estadoTrama === '0') {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: result.payload.data.mensaje });
        FichaEntrega.hideMessage();
      } else if (result.payload.data.estadoTrama === '-1') {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.mensaje}!` });
        FichaEntrega.hideMessage();
      } else {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!` });
        FichaEntrega.hideMessage();
      }
    })
    .catch((error) => {
      this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: '¡Error interno del servidor!' });
      FichaEntrega.hideMessage();
    });
    this.props.fetchAreasVenta();
    this.props.fetchZonas();
    this.props.fetchCompanias();
    this.props.fetchEstadoPedido();
    this.props.fetchEstadoGeneralPlanif();
    this.props.fetchEstadoCancelacion();
    this.props.fetchEstadoGeneralTransp();
    this.props.fetchEstadoGeneralTipoPlaca();
    this.props.fetchEstadoGeneralTipoEntrega();
    this.props.fetchEstadoGeneralMotivoRechazo();



    getFiliales(this.state.checkZonaComer, this.state.checkAreaVta).then((result) => {
      if (result.data.estadoTrama === '1') {
        let LugarEntrega = result.data.filial.map(row => ({ id: row.codFilial, descripcion: row.nomFilial }));
        LugarEntrega.unshift({ id: '000', descripcion: 'CLIENTE' });
        this.setState({LugarEntrega: LugarEntrega});
      }
    });

    getMotivosEntregas(38).then((result) => {
      if (result.data.estadoTrama === '1') {
        this.setState({
          motivosAnulacion: result.data.tablaMaestroLogistica
                              .map(row => ({ id: row.codTipo, descripcion: row.descripcion })),
        });
      }
    });
    getMotivosEntregas(37).then((result) => {
      if (result.data.estadoTrama === '1') {
        this.setState({
          motivosHistorial: result.data.tablaMaestroLogistica
                              .map(row => ({ id: row.codTipo, descripcion: row.descripcion })),
        });
      }
    });
    document.title = 'Divemotor - Entregas';

    this.handleAllOption();
    this.props.fetchIndicadoresEntregas(DATE_INICIO, DATE_FIN);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickComboCheck, true);
    document.removeEventListener('keydown', this.onKeyDown, true);
  }
  onKeyDown(e) {
    const nameComponente = e.target.getAttribute('name');
    const classComponente = e.target.getAttribute('class');
    if (e.keyCode === 27) {
      document.querySelectorAll('.dropdown.dropdown-multi').forEach(dropdown => dropdown.classList.remove('open'));
      this.cerrarModalMasFiltros();
    }
    if (e.keyCode === 13) {
      if (nameComponente === 'btnDropdownToggle' || nameComponente === 'iconDropdownToggle'
        || (classComponente !== null && classComponente.indexOf('checkDeGrillaEnterCerrar')>=0)) {
        this.setState({ selectedID: [], dataRows: [], closeModal: false, countTable: 0 });
        if (document.getElementById('checkBoxAll') !== null) {
          document.getElementById('checkBoxAll').checked = false;
        }
      }
    }
  }


  onChangeNumeroInput(e) {
    this.setState({ numeroInput: e.target.value });
  }

  /** ********************* */
  setNroPag(nuevoTotalRegistros) {
    if (nuevoTotalRegistros < 1) {
      this.setState({ nroPag: PAG_0 });
    } else if (this.state.nroPag === 0) { // iniciacion
      this.setState({ nroPag: PAG_1 });
    }
  }
  setNInicio(nuevoTotalRegistros) {
    if (nuevoTotalRegistros < 1) {
      this.setState({ nInicio: PAG_0 });
    } else if (this.state.nInicio === 0) { // iniciacion
      this.setState({ nInicio: PAG_1 });
    }
  }
  setNFin(nuevoTotalRegistros) {
    if (nuevoTotalRegistros < 1) {
      this.setState({ nFin: PAG_0 });
    } else if (nuevoTotalRegistros === CANT_X_PAG) {
      this.setState({ nFin: CANT_X_PAG });
    } else if (nuevoTotalRegistros < CANT_X_PAG) {
      this.setState({ nFin: nuevoTotalRegistros });
    } else if (this.state.nFin === 0) { // iniciacion
      this.setState({ nFin: CANT_X_PAG });
    } else if (this.state.nInicio === 1) {
      this.setState({ nFin: CANT_X_PAG });
    }
  }
  validacionGrilla() {
    let ocurrioError = false;
    let ocurrioErrorMensaje = '¡Ingrese datos validos!';
    let dateInicio = document.getElementById('startDateInicioInput').value;
    let dateFinal = document.getElementById('startDateFinalInput').value;
    if (dateInicio === '' && dateFinal === '') {
      ocurrioError = false;
    } else if (!moment(dateInicio, 'DD/MM/YYYY', true).isValid()) {
      ocurrioError = true;
      ocurrioErrorMensaje = '¡La fecha inicio es invalida, ingrese una valida, ejemplo:25/12/2017!';
    } else if (!moment(dateFinal, 'DD/MM/YYYY', true).isValid()) {
      ocurrioError = true;
      ocurrioErrorMensaje = '¡La fecha fin es invalida, ingrese una valida, ejemplo:25/12/2017!';
    } else if (!(moment(dateInicio, 'DD/MM/YYYY').toDate() <= moment(dateFinal, 'DD/MM/YYYY').toDate())) {
      ocurrioError = true;
      ocurrioErrorMensaje = '¡La fecha inicio tiene que ser menor ala fecha fin!';
    } else {
      dateInicio = moment(dateInicio, 'DD/MM/YYYY');
      dateFinal = moment(dateFinal, 'DD/MM/YYYY');
    }
    return { ocurrioError, ocurrioErrorMensaje, dateInicio, dateFinal };
  }
  search(estadoSeleccionado, paginaActual, cantidadPorPagina, dateInicio, dateFinal) {
    if (document.getElementById('checkBoxAll') !== null) {
      document.getElementById('checkBoxAll').checked = false;
    }
    if (dateInicio === '') {
      dateInicio = this.state.startDateInicio;
    }
    if (dateFinal === '') {
      dateFinal = this.state.startDateFinal;
    }
    this.props.loadFichasEntrega();
    this.props.fetchFichasEntrega(estadoSeleccionado, paginaActual, cantidadPorPagina,
                                  this.state.searchOption, this.state.numeroInput,
                                  this.state.searchOptionFechas, dateInicio,
                                  dateFinal,
                                  this.state.checkAreaVta, this.state.checkZonaComer,
                                  this.state.checkFilial, this.state.checkCompania,
                                  this.state.vendedorId, this.state.checkMarca,
                                  this.state.modeloInput, this.state.nomClienteInput,
                                  this.state.checkFamilia, this.state.checkEstadoPed,
                                  this.state.checkEstadoPlan, this.state.checkEstadoCancel,
                                  this.state.checkTransportista, this.state.checkTipoPlaca,
                                  this.state.checkTipoEntrega,this.state.respEntrega,
                                  this.state.checkLugarEntrega
    ).then((result) => {
      if (result.payload.data.estadoTrama === '1') {
        getReprogramacion(result.payload.data.entrega.filter(x => x.estaPlan === 'REPROGRAMADO').map(row => row.codPlanEntrVehi)).then((motivos) => {
          this.setState({ reprogramaciones: motivos });
        });

        this.initPaginacion(result.payload.data.totalRegistros,
          result.payload.data.cantidadPaginas);
      } else if (result.payload.data.estadoTrama === '0') {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: result.payload.data.mensaje });
        FichaEntrega.hideMessage();
      } else if (result.payload.data.estadoTrama === '-1') {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.mensaje}!` });
        FichaEntrega.hideMessage();
      } else {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!` });
        FichaEntrega.hideMessage();
      }
    })
    .catch(() => {
      this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: '¡Error interno del servidor!' });
      FichaEntrega.hideMessage();
    });
  }
  handleChangeInicio(date) {
    this.setState({ startDateInicio: date });
  }
  handleChangeFinal(date) {
    this.setState({ startDateFinal: date });
  }
  changeSearchOption(e) {
    this.setState({ searchOption: e.target.value, numeroInput: '' });
  }
  changeSearchOptionFechas(e) {
    this.setState({ searchOptionFechas: e.target.value });
  }
  searchFechas() {
    const validacion = this.validacionGrilla();
    if (validacion.ocurrioError) {
      this.setState({ muestraLoad: 'none', iconAlert: 'ion-alert-circled', colorBackground: '#fcbc61', mensajeAlert: validacion.ocurrioErrorMensaje });
      FichaEntrega.hideMessage();
    } else {
      this.setState({ muestraLoad: 'block' });
      this.search(
        this.state.estado, PAG_1,
        CANT_X_PAG, validacion.dateInicio, validacion.dateFinal
      );
    }
  }
  searchNumero() {
    const validacion = this.validacionGrilla();
    if (validacion.ocurrioError) {
      this.setState({ muestraLoad: 'none', iconAlert: 'ion-alert-circled', colorBackground: '#fcbc61', mensajeAlert: validacion.ocurrioErrorMensaje });
      FichaEntrega.hideMessage();
    } else {
      this.setState({ muestraLoad: 'block' });
      this.search(
        this.state.estado, PAG_1,
        CANT_X_PAG, validacion.dateInicio, validacion.dateFinal
      );
    }
  }
  handleClickComboCheckFiltrar() {
    const validacion = this.validacionGrilla();
    if (validacion.ocurrioError) {
      this.setState({ muestraLoad: 'none', iconAlert: 'ion-alert-circled', colorBackground: '#fcbc61', mensajeAlert: validacion.ocurrioErrorMensaje });
      FichaEntrega.hideMessage();
    } else {
      this.setState({ muestraLoad: 'block', comboSelected: '' });
      this.search(
        this.state.estado, PAG_1,
        CANT_X_PAG, validacion.dateInicio, validacion.dateFinal
      );
    }
    document.querySelectorAll('.dropdown.dropdown-multi').forEach(dropdown => dropdown.classList.remove('open'));
  }

  filtrarMas() {
    const validacion = this.validacionGrilla();
    if (validacion.ocurrioError) {
      this.setState({ muestraLoad: 'none', iconAlert: 'ion-alert-circled', colorBackground: '#fcbc61', mensajeAlert: validacion.ocurrioErrorMensaje });
      FichaEntrega.hideMessage();
    } else {
      this.cerrarModalMasFiltros();
      this.setState({ muestraLoad: 'block', comboSelected: '' });
      this.search(this.state.estado, PAG_1,
        CANT_X_PAG, validacion.dateInicio, validacion.dateFinal
      );
    }
  }
  siguiente() {
    let okSiguiente = false;
    let nroPag;
    if (this.state.cantidadPaginas > this.state.nroPag) {
      nroPag = this.state.nroPag + 1;
      okSiguiente = true;
    }
    if (okSiguiente) {
      const validacion = this.validacionGrilla();
      if (validacion.ocurrioError) {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-alert-circled', colorBackground: '#fcbc61', mensajeAlert: validacion.ocurrioErrorMensaje });
        FichaEntrega.hideMessage();
      } else {
        this.setState({ nroPag });
        if ((this.state.nFin + CANT_X_PAG) < this.state.totalRegistros) {
          this.setState({ nFin: this.state.nFin + CANT_X_PAG });
        } else {
          this.setState({ nFin: this.state.totalRegistros });
        }
        if (this.state.nInicio < this.state.totalRegistros) {
          this.setState({ nInicio: this.state.nInicio + CANT_X_PAG });
        }
        this.setState({ muestraLoad: 'block' });
        this.search(this.state.estado, nroPag, CANT_X_PAG, validacion.dateInicio, validacion.dateFinal);
      }
    }
  }
  atras() {
    let okAtras = false;
    let nroPag;
    if (this.state.nroPag > 1) {
      nroPag = this.state.nroPag - 1;
      okAtras = true;
    }
    if (okAtras) {
      const validacion = this.validacionGrilla();
      if (validacion.ocurrioError) {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-alert-circled', colorBackground: '#fcbc61', mensajeAlert: validacion.ocurrioErrorMensaje });
        FichaEntrega.hideMessage();
      } else {
        this.setState({ nroPag });
        if (this.state.nFin === this.state.totalRegistros) {
          this.setState({ nFin: this.state.nInicio - 1 });
        } else if ((this.state.nFin - CANT_X_PAG) < this.state.totalRegistros &&
                    (this.state.nFin - CANT_X_PAG) !== this.state.totalRegistros) {
          this.setState({ nFin: this.state.nFin - CANT_X_PAG });
        }
        if (this.state.nInicio <= this.state.totalRegistros) {
          this.setState({ nInicio: this.state.nInicio - CANT_X_PAG });
        }
        this.setState({ muestraLoad: 'block' });
        this.search(this.state.estado, nroPag, CANT_X_PAG, validacion.dateInicio, validacion.dateFinal);
      }
    }
  }
  handleClick(estadoNuevo) {
    const validacion = this.validacionGrilla();
    if (validacion.ocurrioError) {
      this.setState({ muestraLoad: 'none', iconAlert: 'ion-alert-circled', colorBackground: '#fcbc61', mensajeAlert: validacion.ocurrioErrorMensaje });
      FichaEntrega.hideMessage();
    } else {
      this.setState({ muestraLoad: 'block', estado: estadoNuevo, nInicio: PAG_1, nroPag: PAG_1 });
      this.search(estadoNuevo, PAG_1, CANT_X_PAG, validacion.dateInicio, validacion.dateFinal);
    }
  }
  initPaginacion(totalRegistros, cantidadPaginas) {
    this.setState({
      muestraLoad: 'none',
      totalRegistros: parseInt(totalRegistros, 10),
      cantidadPaginas: parseInt(cantidadPaginas, 10),
    });
    this.setNroPag(totalRegistros);
    this.setNInicio(totalRegistros);
    this.setNFin(totalRegistros);
  }
  abrirModalMasFiltros() {
    this.setState({ muestraModalMasFiltros: 'block' });
    document.body.style.overflow = 'hidden';
  }
  cerrarModalMasFiltros() {
    this.setState({ muestraModalMasFiltros: 'none' });
    document.body.style.overflow = 'auto';
  }
  cancelarModalMasFiltros() {
    this.cerrarModalMasFiltros();
  }
  handleClickComboCheck(e) {
    const nameComponente = e.target.getAttribute('name');
    const idComponente = e.target.getAttribute('id');
    const classComponente = e.target.getAttribute('class');


    if (nameComponente === 'btnDropdownToggle') {
      if (e.target.parentNode.classList.contains('open')) {
        e.target.parentNode.classList.remove('open');
      } else {
        document.querySelectorAll('.dropdown.kebab').forEach(dropdown => dropdown.classList.remove('open'));
        e.target.parentNode.classList.add('open');
      }
    } else if (nameComponente === 'iconDropdownToggle') {
      if (e.target.parentNode.parentNode.classList.contains('open')) {
        e.target.parentNode.parentNode.classList.remove('open');
      } else {
        document.querySelectorAll('.dropdown.kebab').forEach(dropdown => dropdown.classList.remove('open'));
        e.target.parentNode.parentNode.classList.add('open');
      }
    } else {
      document.querySelectorAll('.dropdown.kebab').forEach(dropdown => dropdown.classList.remove('open'));
    }

    if (nameComponente === 'btnDropdownToggle' || nameComponente === 'iconDropdownToggle'
      || (classComponente !== null && classComponente.indexOf('checkDeGrillaCerrar')>=0)) {
      this.setState({ selectedID: [], dataRows: [], closeModal: false, countTable: 0 });
      if (document.getElementById('checkBoxAll') !== null) {
        document.getElementById('checkBoxAll').checked = false;
      }
    }

    const combo = document.getElementById(this.state.comboSelected);
    if (this.state.comboSelected) {
      if (combo.contains(e.target) && combo !== e.target) {
        return;
      }
    }
    document.querySelectorAll('.dropdown.dropdown-multi').forEach(dropdown => dropdown.classList.remove('open'));
    if (idComponente === this.state.comboSelected || idComponente === null) {
      this.setState({ comboSelected: '' });
    } else if (nameComponente === 'divComboCheck') {
      this.setState({
        comboSelected: idComponente,
      }, e.target.classList.add('open'));
      if (idComponente === COMBO_CHECK_FILIAL) {
        getFiliales(this.state.checkZonaComer, this.state.checkAreaVta).then((result) => {
          if (result.data.estadoTrama === '1') {
            this.setState({
              filialesXAreaVtaXZona: result.data.filial.map(row => ({ id: row.codFilial, descripcion: row.nomFilial })),
            });
          }
        });
      }
      if (idComponente === COMBO_CHECK_FAMILIA) {
        this.props.fetchFamiliaPorAreaVta(this.state.checkAreaVta);
      }
      if (idComponente === COMBO_CHECK_MARCA) {
        this.props.fetchMarcasPorFamilia(this.state.checkAreaVta, this.state.checkFamilia);
      }
    }
  }
  handleInputChangeComboCheck(event, id, idComponente) {
    if (idComponente === COMBO_CHECK_A_VTA) {
      if (event.target.checked === true) {
        this.setState({ checkAreaVta: [...this.state.checkAreaVta, id] });
      } else {
        this.setState({
          checkAreaVta: this.state.checkAreaVta.filter(x => x !== id),
        });
      }
      this.setState({ checkFamilia: [] });
      document.querySelectorAll(`.${COMBO_CHECK_FAMILIA}`).forEach(combo => combo.checked = false);
      this.setState({ checkFilial: [] });
      document.querySelectorAll(`.${COMBO_CHECK_FILIAL}`).forEach(combo => combo.checked = false);
    } else if (idComponente === COMBO_CHECK_ZONACOMER) {
      if (event.target.checked === true) {
        this.setState({ checkZonaComer: [...this.state.checkZonaComer, id] });
      } else {
        this.setState({
          checkZonaComer: this.state.checkZonaComer.filter(x => x !== id),
        });
      }
      this.setState({ checkFilial: [] });
      document.querySelectorAll(`.${COMBO_CHECK_FILIAL}`).forEach(combo => combo.checked = false);
    } else if (idComponente === COMBO_CHECK_FILIAL) {
      if (event.target.checked === true) {
        this.setState({ checkFilial: [...this.state.checkFilial, id] });
      } else {
        this.setState({
          checkFilial: this.state.checkFilial.filter(x => x !== id),
        });
      }
    } else if (idComponente === COMBO_CHECK_COMPANIA) {
      if (event.target.checked === true) {
        this.setState({ checkCompania: [...this.state.checkCompania, id] });
      } else {
        this.setState({
          checkCompania: this.state.checkCompania.filter(x => x !== id),
        });
      }
    } else if (idComponente === COMBO_CHECK_MARCA) {
      if (event.target.checked === true) {
        this.setState({ checkMarca: [...this.state.checkMarca, id] });
      } else {
        this.setState({
          checkMarca: this.state.checkMarca.filter(x => x !== id),
        });
      }
    } else if (idComponente === COMBO_CHECK_FAMILIA) {
      if (event.target.checked === true) {
        this.setState({ checkFamilia: [...this.state.checkFamilia, id] });
      } else {
        this.setState({
          checkFamilia: this.state.checkFamilia.filter(x => x !== id),
        });
      }
      this.setState({ checkMarca: [] });
      document.querySelectorAll(`.${COMBO_CHECK_MARCA}`).forEach(combo => combo.checked = false);
    } else if (idComponente === COMBO_CHECK_ESTADOPED) {
      if (event.target.checked === true) {
        this.setState({ checkEstadoPed: [...this.state.checkEstadoPed, id] });
      } else {
        this.setState({
          checkEstadoPed: this.state.checkEstadoPed.filter(x => x !== id),
        });
      }
    } else if (idComponente === COMBO_CHECK_ESTADOPLAN) {
      if (event.target.checked === true) {
        this.setState({ checkEstadoPlan: [...this.state.checkEstadoPlan, id] });
      } else {
        this.setState({
          checkEstadoPlan: this.state.checkEstadoPlan.filter(x => x !== id),
        });
      }
    } else if (idComponente === COMBO_CHECK_ESTADOCANCEL) {
      if (event.target.checked === true) {
        this.setState({ checkEstadoCancel: [...this.state.checkEstadoCancel, id] });
      } else {
        this.setState({
          checkEstadoCancel: this.state.checkEstadoCancel.filter(x => x !== id),
        });
      }
    } else if (idComponente === COMBO_CHECK_TRANSPORTISTA) {
      if (event.target.checked === true) {
        this.setState({ checkTransportista: [...this.state.checkTransportista, id] });
      } else {
        this.setState({
          checkTransportista: this.state.checkTransportista.filter(x => x !== id),
        });
      }
    } else if (idComponente === COMBO_CHECK_TIPOPLACA) {
      if (event.target.checked === true) {
        this.setState({ checkTipoPlaca: [...this.state.checkTipoPlaca, id] });
      } else {
        this.setState({
          checkTipoPlaca: this.state.checkTipoPlaca.filter(x => x !== id),
        });
      }
    } else if (idComponente === COMBO_CHECK_TIPOENTREGA) {
      if (event.target.checked === true) {
        this.setState({ checkTipoEntrega: [...this.state.checkTipoEntrega, id] });
      } else {
        this.setState({
          checkTipoEntrega: this.state.checkTipoEntrega.filter(x => x !== id),
        });
      }
    }else if (idComponente === COMBO_CHECK_FILIAL_VENTA) {
      if (event.target.checked === true) {
        this.setState({ checkLugarEntrega: [...this.state.checkLugarEntrega, id] });
      } else {
        this.setState({
          checkLugarEntrega: this.state.checkLugarEntrega.filter(x => x !== id),
        });
      }
    }
  }

  handleClearFilter() {
    document.querySelectorAll('.dropdown.dropdown-multi').forEach(combo => combo.classList.remove('open'));
    document.querySelectorAll('input[name=comboCheck]').forEach(combo => combo.checked = false);
    this.setState({
      searchOption: 'npedido',
      numeroInput: '',
      searchOptionFechas: 'fcc',
      startDateInicio: DATE_INICIO_LOAD,
      startDateFinal: DATE_FIN_LOAD,
      checkAreaVta: [],
      checkZonaComer: [],
      checkFilial: [],
      checkCompania: [],
      vendedorName: '',
      vendedorId: '',
      respEntrega:'',
      checkMarca: [],
      modeloInput: '',
      nomClienteInput: '',
      checkFamilia: [],
      checkEstadoPed: [],
      checkEstadoPlan: [],
      checkEstadoCancel: [],
      checkTransportista: [],
      checkTipoPlaca: [],
      checkTipoEntrega: [],
      checkLugarEntrega: [],
    });
    this.setState({ muestraLoad: 'block', estado: 'PR', nInicio: PAG_1, nroPag: PAG_1 });
    document.getElementById('startDateInicioInput').value = DATE_INICIO_LOAD;
    document.getElementById('startDateFinalInput').value = DATE_FIN_LOAD;

    this.datepickerInicio.setState({ inputValue: DATE_INICIO_LOAD });
    this.datepickerFinal.setState({ inputValue: DATE_FIN_LOAD });

    if (document.getElementById('checkBoxAll') !== null) {
      document.getElementById('checkBoxAll').checked = false;
    }
    this.props.loadFichasEntrega();

    this.props.fetchFichasEntrega('PR', PAG_1, CANT_X_PAG, 'npedido', '', 'fcc', DATE_INICIO_LOAD, DATE_FIN_LOAD)
    .then((result) => {
      if (result.payload.data.estadoTrama === '1') {
        getReprogramacion(result.payload.data.entrega.filter(x => x.estaPlan === 'REPROGRAMADO').map(row => row.codPlanEntrVehi)).then((motivos) => {
          this.setState({ reprogramaciones: motivos });
        });

        this.initPaginacion(result.payload.data.totalRegistros,
          result.payload.data.cantidadPaginas);
      } else if (result.payload.data.estadoTrama === '0') {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: result.payload.data.mensaje });
        FichaEntrega.hideMessage();
      } else if (result.payload.data.estadoTrama === '-1') {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.mensaje}!` });
        FichaEntrega.hideMessage();
      } else {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!` });
        FichaEntrega.hideMessage();
      }
    })
    .catch(() => {
      this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: '¡Error interno del servidor!' });
      FichaEntrega.hideMessage();
    });
  }
  selectFDEntregaAll() {
    const entregasRowsId = [];
    const entregasRows = [];
    if (document.getElementById('checkBoxAll').checked) {
      if (this.state.estado === 'PR') {
        this.props.fichasEntrega.entrega.forEach((entregaRow) => {
          entregasRowsId.push(entregaRow.codPlanEntrVehi);
          entregasRows.push(entregaRow);
        });
      } else if (this.state.estado === 'PP' || this.state.estado === 'PE') {
        this.props.fichasEntrega.entrega.forEach((entregaRow) => {
          entregasRowsId.push(entregaRow.numPedidoVeh);
          entregasRows.push(entregaRow);
        });
      } else if (this.state.estado === 'EN') {
        this.props.fichasEntrega.entrega.forEach((entregaRow) => {
          entregasRowsId.push(entregaRow.codPlanEntrVehi);
          entregasRows.push(entregaRow);
        });
      }
      this.setState({ closeModal: true });
    } else {
      this.setState({ closeModal: false });
    }
    this.setState({ selectedID: entregasRowsId, dataRows: entregasRows, countTable: entregasRowsId.length });
  }
  clickDescargas() {
    if (this.state.muestraDescargas === 'none') {
      this.setState({ muestraDescargas: 'block' });
    } else {
      this.setState({ muestraDescargas: 'none' });
    }
  }
  clickDescargarExcel() {
    this.setState({ entregasLogisticaPR: [], entregasLogisticaPP: [], entregasLogisticaPE: [], entregasLogisticaEN: [] });
    this.setState({ muestraLoad: 'block', muestraDescargas: 'none' });
    this.props.fetchFichasEntregaDescargar(this.state.estado, 1, 100,
                                    this.state.searchOption, this.state.numeroInput,
                                    this.state.searchOptionFechas, this.state.startDateInicio,
                                    this.state.startDateFinal,
                                    this.state.checkAreaVta, this.state.checkZonaComer,
                                    this.state.checkFilial, this.state.checkCompania,
                                    this.state.vendedorId, this.state.checkMarca,
                                    this.state.modeloInput, this.state.nomClienteInput,
                                    this.state.checkFamilia, this.state.checkEstadoPed,
                                    this.state.checkEstadoPlan, this.state.checkEstadoCancel,
                                    this.state.checkTransportista, this.state.checkTipoPlaca,
                                    this.state.checkTipoEntrega,this.state.respEntrega,
    ).then((result) => {
      if (result.payload.data.estado === 1) {
        const contentType = 'application/vnd.ms-excel';
        const b64Data = result.payload.data.reporte;
        const fileName = 'entregas.xls';
        saveAs(b64Data, contentType, fileName);
        this.setState({ muestraLoad: 'none' });
      } else if (result.payload.data.estado === 0) {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: result.payload.data.mensaje });
        FichaEntrega.hideMessage();
      } else if (result.payload.data.estado === -1) {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.mensaje}!` });
        FichaEntrega.hideMessage();
      } else {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!` });
        FichaEntrega.hideMessage();
      }
    }).catch(() => {
      this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: '¡Error interno del servidor!' });
      FichaEntrega.hideMessage();
    });
  }

  /** ******************************************************************************************** */


  onClickProgramaEntrega = () => {
    const { dataRows } = this.state;
    let MasivoPedidos = [];

    this.setState({ closeModal: false });
    // numProfVeh , numFichaVta

    MasivoPedidos = dataRows.map((entry) =>  entry.numPedidoVeh);

    getvalidacionPedidos(MasivoPedidos.toString()).then((result)=>{

      console.log(result);

      if(result.data.estadoTrama === '1' ){
        let Masivo = [];
          Masivo = dataRows.filter(({ codPropietarioVeh,numFichaVta,lugDespachoVeh }) =>
          (codPropietarioVeh === dataRows[0].codPropietarioVeh && numFichaVta === dataRows[0].numFichaVta && lugDespachoVeh === dataRows[0].lugDespachoVeh ));

      const currentEvent = [];

      dataRows.forEach((entry) => {
        let obj = {},
          pedido = [],
          l = {};
        obj.numPedi = entry.numPedidoVeh;
        obj.chasis = entry.numChasis;
        pedido.push(obj);

        l.codPlanEntrVehi = entry.codPlanEntrVehi;
        l.nomEmpresa = entry.desCliente;
        l.fechProinicio = '';
        l.fechProfin = '';
        l.pedidos = pedido;
        
        currentEvent.push(l);
      });

      this.setState({ currentEvent });

      this.handleChangeModalFrom(false);
      }else{
        this.validandoEnvioMesaje(result.data.mensaje)
      }
    }).catch((error)=>{
      this.validandoEnvioMesaje('¡Error interno del servidor!')

    });


  }

  onClickReprogramaEntrega =()=> {
    const { dataRows } = this.state;

    let MasivoPedidos= [];

    this.setState({ closeModal: false });
    // Validacion programacion masiva
    MasivoPedidos =  dataRows.map((entry) =>  entry.numPedidoVeh);

    getvalidacionPedidos(MasivoPedidos.toString()).then((result)=>{

      console.log(result);

      if(result.data.estadoTrama === '1' ){
      // evento Programado Calendar
      let Masivo = [];

      Masivo = dataRows.filter(({ codPropietarioVeh,numFichaVta,lugDespachoVeh }) =>
                            (codPropietarioVeh === dataRows[0].codPropietarioVeh &&
                              numFichaVta === dataRows[0].numFichaVta &&
                              lugDespachoVeh === dataRows[0].lugDespachoVeh ));


      const currentWeek =   moment(Masivo.fecProgramada).isoWeeks() ;
      const date = [];
      const fromEntrega = {
        codFilial: Masivo[0].codFilial2,
        emaContConfi:Masivo[0].emaContConfi,
        labelcodLugEntrega: Masivo[0].tipLugar,
        codLugEntrega: Masivo[0].tipLugEnt,
        codTransp: Masivo[0].codTranEnt,
        labelcodTransp: Masivo[0].tipTrans,
        codUsuResp: Masivo[0].codUsuaResp,
        dirContacto: Masivo[0].dirEntrVehi === null ? '' : Masivo[0].dirEntrVehi,
        emaContacto: Masivo[0].emaContRece,
        fecProgramada: Masivo[0].fecProgramada,
        invitacionCal: '',
        nomContacto: Masivo[0].nomContRece,
        obsContacto: Masivo[0].obsEntrVeh,
        personalAd: [],
        listaPerAd: [],
        listItemsUsu: [],
        telContacto: Masivo[0].telContRece,
        tipPlaca: Masivo[0].codTipoPlaca,
        codEntrega: Masivo[0].codTranEnt,
        labelcodEntrega: Masivo[0].tipEnt,
        codPlanEntrVehi: Masivo[0].codPlanEntrVehi,
        numHorEntr: Masivo[0].numHorEntr,
      };




      const startOfWeek = moment().isoWeek(currentWeek).startOf('isoWeek');
      const endOfWeek = moment().isoWeek(currentWeek).endOf('isoWeek');
      let day = startOfWeek;

      while (day <= endOfWeek) {
        date.push(moment(day.toDate()).format('DD/MM/YYYY'));
        day = day.clone().add(1, 'd');
      }



      const currentEvent = [];

      dataRows.forEach((entry) => {
        let obj = {},
          pedido = [],
          l = {};
        obj.numPedi = entry.numPedidoVeh;
        obj.chasis = entry.numChasis;
        pedido.push(obj);

        l.codPlanEntrVehi = entry.codPlanEntrVehi;
        l.nomEmpresa = entry.desCliente;
        l.fechProinicio = '';
        l.fechProfin = '';
        l.pedidos = pedido;

        currentEvent.push(l);
      });

      this.setState({ currentEvent });


      const promises = [];
      const lista = [];
      const objDisponibilidad = [];

      promises.push(this.props.listarProgramacionXsede('PR', Masivo[0].codFilial2, date[0], date[6]));
      promises.push(this.props.personasAdicionales(Masivo[0].codPlanEntrVehi));
        // promises.push(this.props.programacionCalendario(Rows.codFilial2, Rows.codFilial, Rows.codFamiliaVeh, 'N'));
      promises.push(this.props.programacionCalendario(Masivo[0].codFilial2, Masivo[0].codFilial, Masivo[0].codFamiliaVeh, 'N'));

      Promise.all(promises).then((results) => {
          // agregar personas adicionales
          //  const lsperall = [];
        const lsper = [];
        if (this.props.Adpersonas) {
          this.props.Adpersonas.map(
                Row => (
                    fromEntrega.listaPerAd.push({ id: Masivo[0].codUsuAdic, apellido: Masivo[0].nomUsuAdic })
                ));
          this.props.Adpersonas.map(
                    Row => (
                      lsper.push(Row.codUsuAdic)
                ));
        }

        fromEntrega.personalAd = lsper;
          //  fromEntrega.listaPerAd = lsperall;
        fromEntrega.listItemsUsu.push({ id: Masivo[0].codUsuaResp, apellido: Masivo[0].nomUsuaResp });



        const eventos = _.differenceBy(this.props.listaProgramacion, this.state.dataRows, 'codPlanEntrVehi');



        eventos.forEach((entry) => {
          const lispedido = [];
          lispedido.push({ numPedi: entry.numPedidoVeh, chasis: entry.numChasis });
          const obj = {};
          obj.codPlanEntrVehi = entry.codPlanEntrVehi;
          obj.nomEmpresa = entry.desCliente;
          obj.fechProinicio = moment(entry.fecProgramada).format('DD/MM/YYYY HH:mm');
          obj.fechProfin = moment(entry.fecProgramada).add(entry.numHorEntr, 'hours').format('DD/MM/YYYY HH:mm');
          obj.pedidos = lispedido;
          lista.push(
                obj
              );
        });

        objDisponibilidad.push(results[2].payload.data.disponibilidad[0]);
      });

      getTipoReprogramacion().then((results) => {
        this.setState({ listaMotivoReprogramacion: results.data.tablaMaestroLogistica });
      });

      this.setState({
        dataProgramar: lista,
        datafromEntrega: fromEntrega,
        disponibilidad: objDisponibilidad });
      this.handleChangeModalReFrom(false);


      }else{
        this.validandoEnvioMesaje(result.data.mensaje)
      }

    }).catch((error)=>{
      this.validandoEnvioMesaje('¡Error interno del servidor!')

    });


  }

 validandoEnvioMesaje = (mensaje) =>{
  this.setState({
    iconAlert: 'ion-alert-circled',
    colorBackground: '#fcbc61',
    mensajeAlert: mensaje });
  this.setState({
    dataRows: [],
    selectedID: [],
  });
  document.getElementById('checkBoxAll').checked = false;
  FichaEntrega.hideMessage();

 }





  handleOnClickProgramer(id, Rows) {
    document.querySelectorAll('.dropdown.kebab').forEach(combo => combo.classList.remove('open'));

    this.setState({
      selectedID: [],
      dataRows: [],
      programacionRow:Rows,
    });
    this.setState({
      selectedID: [...this.state.selectedID, id],
      dataRows: [...this.state.dataRows, Rows],
    });
    // evento Programado Calendar
    const l = {};
    const pedido = [],
      currentEvent = [];
    pedido.push({ numPedi: Rows.numPedidoVeh, chasis: Rows.numChasis });
    l.codPlanEntrVehi = Rows.codPlanEntrVehi;
    l.nomEmpresa = Rows.desCliente;
    l.fechProinicio = moment(Rows.fecProgramada).format('DD/MM/YYYY HH:mm');
    l.fechProfin = moment(Rows.fecProgramada).add(1, 'hours').format('DD/MM/YYYY HH:mm');
    l.pedidos = pedido;
    currentEvent.push(l);
    this.setState({ currentEvent });
    getContactoCliente(Rows.codCliente).then((result) => {
      this.setState({ contactoCliente: result.data.contactoCliente });
    });


    this.handleChangeModalFrom(false);
  }

  handleOnClickReprogramer(id, Rows) {

    document.querySelectorAll('.dropdown.kebab').forEach(combo => combo.classList.remove('open'));

    this.setState({
      selectedID: [],
      dataRows: [],
      programacionRow:Rows,
    });
    this.setState({
      selectedID: [...this.state.selectedID, id],
      dataRows: [...this.state.dataRows, Rows],
    });


    const currentWeek = moment(Rows.fecProgramada).isoWeeks();

    const startOfWeek = moment().isoWeek(currentWeek).startOf('isoWeek');
    const endOfWeek = moment().isoWeek(currentWeek).endOf('isoWeek');
    const date = [];
    let day = startOfWeek;

    while (day <= endOfWeek) {
      date.push(moment(day.toDate()).format('DD/MM/YYYY'));
      day = day.clone().add(1, 'd');
    }


    const fromEntrega = {
      codFilial: Rows.codFilial2,
      labelcodLugEntrega: Rows.tipLugar,
      codLugEntrega: Rows.tipLugEnt,
      codTransp: Rows.codTranEnt,
      labelcodTransp: Rows.tipTrans,
      codUsuResp: Rows.codUsuaResp,
      dirContacto: Rows.dirEntrVehi === null ? '' : Rows.dirEntrVehi,
      emaContacto: Rows.emaContRece,
      fecProgramada: Rows.fecProgramada,
      invitacionCal: '',
      nomContacto: Rows.nomContRece,
      obsContacto: Rows.obsEntrVeh,
      personalAd: [],
      listaPerAd: [],
      listItemsUsu: [],
      telContacto: Rows.telContRece,
      tipPlaca: Rows.codTipoPlaca,
      codEntrega: Rows.codTranEnt,
      labelcodEntrega: Rows.tipEnt,
      codPlanEntrVehi: Rows.codPlanEntrVehi,
      numHorEntr: Rows.numHorEntr,
      emaContConfi:Rows.emaContConfi,

    };
    // evento Programado Calendar
    const l = {};
    const pedido = [],
      currentEvent = [];
    pedido.push({ numPedi: Rows.numPedidoVeh, chasis: Rows.numChasis });
    l.codPlanEntrVehi = Rows.codPlanEntrVehi;
    l.nomEmpresa = Rows.desCliente;
    l.fechProinicio = moment(Rows.fecProgramada).format('DD/MM/YYYY HH:mm');
    l.fechProfin = moment(Rows.fecProgramada).add(Rows.numHorEntr, 'hours').format('DD/MM/YYYY HH:mm');
    l.pedidos = pedido;
    currentEvent.push(l);
    this.setState({ currentEvent });

    const promises = [];
    const lista = [];
    const objDisponibilidad = [];

    let valueLugar = Rows.codFilial;
    let valueFam = Rows.codFamiliaVeh;
    if (Rows.tipLugEnt === '2') {
      valueLugar = '000';
      valueFam = '000';
    }


    promises.push(this.props.listarProgramacionXsede('PR', Rows.codFilial2, date[0], date[6]));
    promises.push(this.props.personasAdicionales(Rows.codPlanEntrVehi));
    promises.push(this.props.programacionCalendario(Rows.codFilial2, valueLugar, valueFam, 'N', Rows.tipLugEnt));
    Promise.all(promises)
    .then((results) => {
      // agregar personas adicionales
    //  const lsperall = [];
      const lsper = [];
      if (this.props.Adpersonas) {
        this.props.Adpersonas.map(
            Row => (
                fromEntrega.listaPerAd.push({ id: Row.codUsuAdic, apellido: Row.nomUsuAdic })
            ));
        this.props.Adpersonas.map(
                Row => (
                  lsper.push(Row.codUsuAdic)
            ));
      }
      fromEntrega.personalAd = lsper;
    //  fromEntrega.listaPerAd = lsperall;
      fromEntrega.listItemsUsu.push({ id: Rows.codUsuaResp, apellido: Rows.nomUsuaResp });

      const eventos = results[0].payload.data.entrega
      .filter(({ codPlanEntrVehi }) => codPlanEntrVehi !== Rows.codPlanEntrVehi);
      eventos.forEach((entry) => {
        const lispedido = [];
        lispedido.push({ numPedi: entry.numPedidoVeh, chasis: entry.numChasis });
        const obj = {};
        obj.codPlanEntrVehi = entry.codPlanEntrVehi;
        obj.nomEmpresa = entry.desCliente;
        obj.fechProinicio = moment(entry.fecProgramada).format('DD/MM/YYYY HH:mm');
        obj.fechProfin = moment(entry.fecProgramada).add(entry.numHorEntr, 'hours').format('DD/MM/YYYY HH:mm');
        obj.pedidos = lispedido;
        lista.push(
            obj
          );
      });

      objDisponibilidad.push(results[2].payload.data.disponibilidad[0]);
    });

    getTipoReprogramacion().then((results) => {
      this.setState({ listaMotivoReprogramacion: results.data.tablaMaestroLogistica });
    });

    this.setState({
      dataProgramar: lista,
      datafromEntrega: fromEntrega,
      disponibilidad: objDisponibilidad });

    this.handleChangeModalReFrom(false);
  }


  handleOnClickProgramerAll = (id, Rows) => {
    console.log('alerta' + id);
    if (this.state.selectedID.indexOf(id)>=0) {
      this.state.selectedID.splice(this.state.selectedID.indexOf(id), 1);
      this.state.dataRows.splice(this.state.dataRows.indexOf(Rows), 1);
    } else {
      this.setState({
        selectedID: [...this.state.selectedID, id],
        dataRows: [...this.state.dataRows, Rows],
        closeModal: true,
      });
    }
    this.setState({
      countTable: this.state.selectedID.length,
    });
  }

  closeModalProgramacion(){

    this.setState({ modalavaluefrom: '' });
    document.body.style.overflow = 'auto';

  }

  handleChangeModalFrom(value, valueMensaje, lstPedido) {
    if (value) {
      this.setState({
        selectedID: [],
        dataRows: [],

      });
    }

    if (value === true && valueMensaje === false) {
      this.setState({

        iconAlert: 'ion-checkmark-circled',
        colorBackground: '#1DB89B',
        mensajeAlert: '¡ Se registró correctamente !',
        numeroInput: lstPedido,
      });


      FichaEntrega.hideMessage();
    }

    this.setState({ modalavaluefrom: value ? '' : 'modalshowFilter' });
    if (!value) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
      this.onClickOptinTab('PR', CANT_X_PAG, PAG_1);
    }
  }


  handleChangeModalReFrom(value, valueMensaje) {
    if (value) {
      this.setState({
        selectedID: [],
        dataRows: [],
      });
    }
    if (value === true && valueMensaje === false) {
      this.setState({

        iconAlert: 'ion-checkmark-circled',
        colorBackground: '#1DB89B',
        mensajeAlert: '¡ Se reprogramo correctamente !',
      });
      FichaEntrega.hideMessage();
    }
    this.setState({ modalavalueRefrom: value ? '' : 'modalshowFilter' });
    if (!value) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
      this.onClickOptinTab('PR', CANT_X_PAG, PAG_1);
    }
  }
  onClickOptinTab(value, cantidadxPag, nroPag) {
    this.setState({ muestraLoad: 'block', selectedID: [] });
    if (this.state.estado !== value) {
      this.setState({ estado: value });
    }
    const validacion = this.validacionGrilla();
    if (validacion.ocurrioError) {
      this.setState({ muestraLoad: 'none', iconAlert: 'ion-alert-circled', colorBackground: '#fcbc61', mensajeAlert: validacion.ocurrioErrorMensaje });
      FichaEntrega.hideMessage();
    } else {
      this.search(value, PAG_1, CANT_X_PAG, validacion.dateInicio, validacion.dateFinal);
    }
  }


  abrirModalAprobarRechazar(id, Rows, tipo) {
    this.aprobarRechazarPase.limpiarInputs(Rows);
    this.setState({ tipoModal: tipo, muestraModalAprobarRechazar: 'block' });
    if (id === null) {
      this.setState({ arrayCodigoDetalle: this.state.selectedID });
    } else {
      this.setState({ arrayCodigoDetalle: [id] });
    }
    document.body.style.overflow = 'hidden';
  }
  cerrarModalAprobarRechazar() {
    this.setState({ muestraModalAprobarRechazar: 'none' });
    document.body.style.overflow = 'auto';
  }
  traerColaboradores(value) {
    this.props.fetchColaboradores(value);
  }
  limpiarColaboradores() {
    this.props.clearColaboradores();
  }
  clickAccionAprobarRechazar(aprobarRechazarPaseAprogramacion) {
    this.setState({ muestraLoad: 'block' });
    const promises = [];
    this.state.arrayCodigoDetalle.forEach((fel) => {
      promises.push(postEntregasPaseAprogramacion(fel, aprobarRechazarPaseAprogramacion));
    });
    Promise.all(promises)
    .then((results) => {
      const estadoTrama = results.map(result => result.data);

      let resultadoTramaUno = [],
        resultadoTramaCero = [],
        resultadoTramaMenosUno = [],
        resultadoTramaOtros = [];
      estadoTrama.forEach((trama) => {
        if (trama.estadoTrama === '1') {
          resultadoTramaUno.push('¡Se registro satisfactoriamente!');
        } else if (trama.estadoTrama === '0') {
          resultadoTramaCero.push(`¡${trama.mensaje}!`);
        } else if (trama.estadoTrama === '-1') {
          resultadoTramaMenosUno.push(`¡Error interno del servidor:${trama.mensaje}!`);
        } else {
          resultadoTramaOtros.push(`¡Error interno del servidor:${trama.estadoTrama}!`);
        }
      });
      if (resultadoTramaUno.length === this.state.arrayCodigoDetalle.length) { // todo ok
        this.cerrarModalAprobarRechazar();
        this.search(this.state.estado, PAG_1, CANT_X_PAG, '', '');
        this.setState({ arrayCodigoDetalle: [], selectedID: [], dataRows: [], closeModal: false, iconAlert: 'ion-checkmark-circled', colorBackground: '#1DB89B', mensajeAlert: resultadoTramaUno[0] });
        FichaEntrega.hideMessage();
      } else if (resultadoTramaCero.length === this.state.arrayCodigoDetalle.length) {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: resultadoTramaCero[0] });
        FichaEntrega.hideMessage();
      } else if (resultadoTramaMenosUno.length === this.state.arrayCodigoDetalle.length) {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: resultadoTramaMenosUno[0] });
        FichaEntrega.hideMessage();
      } else if (resultadoTramaOtros.length === this.state.arrayCodigoDetalle.length) {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: resultadoTramaOtros[0] });
        FichaEntrega.hideMessage();
      } else {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: '¡Error inesperado, interno del servidor!' });
        FichaEntrega.hideMessage();
      }
    }).catch(() => {
      this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: '¡Error interno del servidor!' });
      FichaEntrega.hideMessage();
    });
  }

  abrirModalAnularEntregaProgramada(id, Rows, tipo) {

    if(Rows!==null){
      this.anularEntregaProgramada.limpiarInputs(Rows);
    }else{
      this.anularEntregaProgramada.limpiarInputs(this.state.dataRows[0]);

    }

    this.setState({ muestraModalAnularEntregaProgramada: 'block', programacionRow:Rows });
    if (id === null) {
      this.setState({ arrayCodigoDetalle: this.state.selectedID });
    } else {
      this.setState({ arrayCodigoDetalle: [id] });
    }
    document.body.style.overflow = 'hidden';
  }
  cerrarModalAnularEntregaProgramada() {
    this.setState({ muestraModalAnularEntregaProgramada: 'none' });
    document.body.style.overflow = 'auto';
  }
  clickAnularEntrega(anularEntregaProgramada) {
    this.setState({ muestraLoad: 'block' });
    const promises = [];
    this.state.arrayCodigoDetalle.forEach((fel) => {
      promises.push(postEntregasAnularEntregaProg(fel, anularEntregaProgramada));
    });
    Promise.all(promises)
    .then((results) => {
      const estadoTrama = results.map(result => result.data);
      let resultadoTramaUno = [],
        resultadoTramaCero = [],
        resultadoTramaMenosUno = [],
        resultadoTramaOtros = [];
      estadoTrama.forEach((trama) => {
        if (trama.estadoTrama === '1') {
          resultadoTramaUno.push('¡Se registro satisfactoriamente!');
        } else if (trama.estadoTrama === '0') {
          resultadoTramaCero.push(`¡${trama.mensaje}!`);
        } else if (trama.estadoTrama === '-1') {
          resultadoTramaMenosUno.push(`¡Error interno del servidor:${trama.mensaje}!`);
        } else {
          resultadoTramaOtros.push(`¡Error interno del servidor:${trama.estadoTrama}!`);
        }
      });
      if (resultadoTramaUno.length === this.state.arrayCodigoDetalle.length) { // todo ok
        this.cerrarModalAnularEntregaProgramada();
        this.search(this.state.estado, PAG_1, CANT_X_PAG, '', '');
        this.setState({ arrayCodigoDetalle: [], selectedID: [], dataRows: [], closeModal: false, iconAlert: 'ion-checkmark-circled', colorBackground: '#1DB89B', mensajeAlert: resultadoTramaUno[0] });
        FichaEntrega.hideMessage();
      } else if (resultadoTramaCero.length === this.state.arrayCodigoDetalle.length) {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: resultadoTramaCero[0] });
        FichaEntrega.hideMessage();
      } else if (resultadoTramaMenosUno.length === this.state.arrayCodigoDetalle.length) {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: resultadoTramaMenosUno[0] });
        FichaEntrega.hideMessage();
      } else if (resultadoTramaOtros.length === this.state.arrayCodigoDetalle.length) {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: resultadoTramaOtros[0] });
        FichaEntrega.hideMessage();
      } else {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: '¡Error inesperado, interno del servidor!' });
        FichaEntrega.hideMessage();
      }
    }).catch(() => {
      this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: '¡Error interno del servidor!' });
      FichaEntrega.hideMessage();
    });
  }
  cerrarModalVerDetalle() {
    this.setState({ muestraModalVerDetalle: 'none' });
    document.body.style.overflow = 'auto';
  }
  abrirModalVerDetalle(codPlanEntrVeh) {
    this.detalleEntregasLogistica.limpiarInputs(null);
    if (codPlanEntrVeh === null) {
      this.setState({ iconAlert: 'ion-alert-circled', colorBackground: '#fcbc61', mensajeAlert: '¡El registro no tiene planificación de entrega!' });
      FichaEntrega.hideMessage();
    } else {
      this.setState({ muestraLoad: 'block', arrayCodigoDetalle: [codPlanEntrVeh] });
      const promises = [];
      promises.push(this.props.fetchFichaEntrega(codPlanEntrVeh, this.state.estado));
      promises.push(this.props.fetchHistorial(codPlanEntrVeh));
      promises.push(this.props.personasAdicionales(codPlanEntrVeh));
      Promise.all(promises)
      .then(() => this.setState({ muestraLoad: 'none', muestraModalVerDetalle: 'block' }));
      document.body.style.overflow = 'hidden';
    }
  }
  cerrarModalVerRechazo() {
    this.setState({ muestraModalVerRechazo: 'none' });
    document.body.style.overflow = 'auto';
  }
  abrirModalVerRechazo(codPlanEntrVeh) {
    if (codPlanEntrVeh === null) {
      this.setState({ iconAlert: 'ion-alert-circled', colorBackground: '#fcbc61', mensajeAlert: '¡El registro no tiene planificación de entrega!' });
      FichaEntrega.hideMessage();
    } else {
      this.setState({ muestraLoad: 'block', arrayCodigoDetalle: [codPlanEntrVeh] });
      const promises = [];
      promises.push(this.props.fetchFichaEntrega(codPlanEntrVeh, this.state.estado));
      Promise.all(promises)
      .then(() => this.setState({ muestraLoad: 'none', muestraModalVerRechazo: 'block' }));
      document.body.style.overflow = 'hidden';
    }
  }
  clickComentar(comentar) {
    this.setState({ muestraLoad: 'block' });
    const promises = [];
    const codigoDetalle = this.state.arrayCodigoDetalle[0];
    promises.push(postEntregasHistorial(codigoDetalle, comentar));
    Promise.all(promises)
    .then((result) => {
      if (result[0].data.estadoTrama === '1') {
        this.detalleEntregasLogistica.ocultarComentario();
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-checkmark-circled', colorBackground: '#1DB89B', mensajeAlert: '¡Se registro satisfactoriamente!' });
        FichaEntrega.hideMessage();
        this.props.fetchHistorial(codigoDetalle);
      } else if (result[0].data.estadoTrama === '0') {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡${result[0].data.mensaje}!` });
        FichaEntrega.hideMessage();
      } else if (result[0].data.estadoTrama === '-1') {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result[0].data.mensaje}!` });
        FichaEntrega.hideMessage();
      } else {
        this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result[0].data.estadoTrama}!` });
        FichaEntrega.hideMessage();
      }
    }).catch(() => {
      this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: '¡Error interno del servidor!' });
      FichaEntrega.hideMessage();
    });
  }


  handleAllOption() {
    if (this.state.closeModal === false) {
      return (<div />);
    } else if (this.state.estado === 'PP' && this.state.countTable > 0) {
      return (
        <div className='alert alert-actions js-open-flex' id='entrega-tableActions'>
          <p><span className='bold'>{this.state.selectedID.length} </span><span className='regular'>Elementos seleccionados</span></p>
          <button className='btn btn-blue' onClick={() => this.onClickProgramaEntrega()}>Programar entrega
          </button>
          <button
            className='btn  checkDeGrillaCerrar btn-close-masivo'
            onClick={() => this.setState({ selectedID: [], dataRows: [], closeModal: true, countTable: 0 }, () => document.getElementById('checkBoxAll').checked = false)}
          >
            <i className='icon ion-android-cancel' />

          </button>
        </div>
      );
    } else if (this.state.estado === 'PE' && this.state.selectedID.length > 0) {
      return (
        <div className='alert alert-actions js-open-flex' id='entregaPendientes-tableActions'>
          <p><span className='bold'>{this.state.selectedID.length} </span><span className='regular'>Elementos seleccionados</span></p>
          <button className='btn btn-success' data-toggle='modal' data-target='#aprobarPaseEntrega' onClick={() => this.abrirModalAprobarRechazar(null, null, 'aprobar')}>Aprobar
        </button>
          <button className='btn btn-danger' data-toggle='modal' data-target='#rechazarPaseEntrega' onClick={() => this.abrirModalAprobarRechazar(null, null, 'rechazar')}>Rechazar
        </button>
          <button
            className='btn  checkDeGrillaCerrar btn-close-masivo'
            onClick={() => this.setState({ selectedID: [], dataRows: [], closeModal: true, countTable: 0 }, () => document.getElementById('checkBoxAll').checked = false)}
          >
            <i className='icon ion-android-cancel' />
          </button>
        </div>
      );
    } else if (this.state.estado === 'PR' && this.state.countTable > 0) {
      return (
        <div className='alert alert-actions js-open-flex' id='entregaProgramados-tableActions'>
          <p><span className='bold'>{this.state.selectedID.length} </span><span className='regular'>Elementos seleccionados</span></p>
          <button className='btn btn-blue' onClick={() => this.onClickReprogramaEntrega()} >Reprogramar entrega
          </button>
          <button className='btn btn-danger' data-toggle='modal' data-target='#anularEntrega' onClick={() => this.abrirModalAnularEntregaProgramada(null, null)}>Anular entrega
          </button>
          <button
            className='btn  checkDeGrillaCerrar btn-close-masivo'
            onClick={() => this.setState({ selectedID: [], dataRows: [], closeModal: true, countTable: 0 }, () => document.getElementById('checkBoxAll').checked = false)}
          >
            <i className='icon ion-android-cancel ' />
          </button>

        </div>
      );
    }
  }
 renderTable() {
    if (this.state.estado === 'PR') {
      return(
      <TablaProgramados
          selectFDEntregaAll={this.selectFDEntregaAll}
          fichasEntrega = {!this.props.fichasEntrega?[]:this.props.fichasEntrega.entrega}
          handleOnClickProgramerAll = {this.handleOnClickProgramerAll}
          handleOnClickReprogramer = {this.handleOnClickReprogramer}
          abrirModalAnularEntregaProgramada = {this.abrirModalAnularEntregaProgramada}
          onClickReprogramaEntrega = {this.onClickReprogramaEntrega}
          abrirModalVerRechazo = {this.abrirModalVerRechazo}
          abrirModalVerDetalle = {this.abrirModalVerDetalle}
          reprogramaciones = {this.state.reprogramaciones}
          selectedID = {this.state.selectedID}
        />);
    } else if (this.state.estado === 'PP' ) {
      return (
        <TablaPorProgramar
          selectFDEntregaAll={this.selectFDEntregaAll}
          fichasEntrega = {!this.props.fichasEntrega?[]:this.props.fichasEntrega.entrega}
          handleOnClickProgramerAll = {this.handleOnClickProgramerAll}
          handleOnClickProgramer = {this.handleOnClickProgramer}
          handleOnClickReprogramer = {this.handleOnClickReprogramer}
          abrirModalAnularEntregaProgramada = {this.abrirModalAnularEntregaProgramada}
          onClickReprogramaEntrega = {this.onClickReprogramaEntrega}
          onClickProgramaEntrega = {this.onClickProgramaEntrega}
          selectedID = {this.state.selectedID}
        />
      );
    } else if ( this.state.estado === 'PE') {
      return (
          <TablaPendientes
          fichasEntrega = {!this.props.fichasEntrega?[]:this.props.fichasEntrega.entrega}
          />
      );
    }else if (this.state.estado === 'EN') {
      return (
        <TablaEntregados
          fichasEntrega = {!this.props.fichasEntrega?[]:this.props.fichasEntrega.entrega}
          abrirModalVerDetalle={this.abrirModalVerDetalle}
        />
      );
    }if (this.state.estado === 'TO') {
      return(
      <TablaTodos
          selectFDEntregaAll={this.selectFDEntregaAll}
          fichasEntrega = {!this.props.fichasEntrega?[]:this.props.fichasEntrega.entrega}
          handleOnClickProgramerAll = {this.handleOnClickProgramerAll}
          handleOnClickReprogramer = {this.handleOnClickReprogramer}
          abrirModalAnularEntregaProgramada = {this.abrirModalAnularEntregaProgramada}
          onClickReprogramaEntrega = {this.onClickReprogramaEntrega}
          abrirModalVerRechazo = {this.abrirModalVerRechazo}
          abrirModalVerDetalle = {this.abrirModalVerDetalle}
          reprogramaciones = {this.state.reprogramaciones}
          selectedID = {this.state.selectedID}
        />);
    }
  }
  nombreDelEstadoProgramacion() {
    if (this.state.estado === 'PR') {
      return 'Programados';
    } else if (this.state.estado === 'PP') {
      return 'Por programar';
    } else if (this.state.estado === 'PE') {
      return 'Pendientes';
    } else if (this.state.estado === 'EN') {
      return 'Entregados';
    }
  }
  render() {
    return (
      <div >

        <div className='pageHead'>
          <MainRowSection clickDescargarExcel={this.clickDescargarExcel} clickDescargas={this.clickDescargas} muestraDescargas={this.state.muestraDescargas} />

          <div className='pageHead-rowContainer'>
            <div className='pageHead-kpis wrapper' >
              <KpisSection indicadores={this.props.indicadoresEntregas} />
            </div>
          </div>

          <div className='pageHead-rowContainer'>
            <div className='pageHead-filters wrapper'>
              <div className='pageHead-filters-search'>
                <div className='fSearch'>
                  <div className='fSearch-filter form-control'>
                    <select value={this.state.searchOption} onChange={this.changeSearchOption} >
                      <option value='npedido'>N° Pedido</option>
                      <option value='nchasis'>N° Chasis</option>
                      <option value='nfichaVenta'>N° Ficha de Venta</option>
                      <option value='nproforma'>N° Proforma</option>
                    </select>
                  </div>
                  <input
                    type='text'
                    className='fSearch-search form-control checkDeGrillaEnterCerrar'
                    value={this.state.numeroInput}
                    onChange={this.onChangeNumeroInput}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        this.searchNumero();
                      }
                    }}
                  />
                  <button
                    className='btn btn-dark fSearch-go checkDeGrillaCerrar'
                    type='button'
                    title='Filtrar'
                    onClick={() => this.searchNumero()}
                  ><i className='ion-android-arrow-forward' /></button>
                </div>
              </div>
              <div className='pageHead-filters-drops'>
                <div className='fSearch'>
                  <div className='fSearch-filter form-control'><i className='ion-calendar' />
                    <select value={this.state.searchOptionFechas} onChange={this.changeSearchOptionFechas} >
                      <option value='fcc'>F° C. Comercial</option>
                      <option value='fcl'>F° C. Logística</option>
                      <option value='fentregasprogra'>F° Entrega Programada</option>
                      <option value='frecepcionplacas'>F° Recep. Placa</option>
                    </select>
                  </div>
                  <DatePicker
                    selected={this.state.startDateInicio}
                    className='form-control fSearch-search date-picker ng-pristine ng-valid ng-isolate-scope ng-touched checkDeGrillaEnterCerrar'
                    dateFormat='DD/MM/YYYY'
                    locale='es'
                    onChange={this.handleChangeInicio}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        e.preventDefault();
                        this.searchFechas();
                      }
                    }}
                    id='startDateInicioInput'
                    ref={(datepicker) => { this.datepickerInicio = datepicker; }}
                  />
                  <DatePicker
                    selected={this.state.startDateFinal}
                    className='form-control fSearch-search date-picker ng-pristine ng-valid ng-isolate-scope ng-touched checkDeGrillaEnterCerrar'
                    dateFormat='DD/MM/YYYY'
                    locale='es'
                    onChange={this.handleChangeFinal}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        e.preventDefault();
                        this.searchFechas();
                      }
                    }}
                    id='startDateFinalInput'
                    ref={(datepicker) => { this.datepickerFinal = datepicker; }}
                  />
                  <button
                    className='btn btn-dark fSearch-go checkDeGrillaCerrar'
                    onClick={this.searchFechas}
                    title='Filtrar'
                  ><i className='ion-android-arrow-forward' /></button>
                </div>
                <ComboCheck
                  name='Area de Venta'
                  idComponente={COMBO_CHECK_A_VTA}
                  onClickFiltrar={this.handleClickComboCheckFiltrar}
                  onClickCheck={this.handleInputChangeComboCheck}
                  lista={!this.props.areasVenta ? [] : this.props.areasVenta}
                  id='id'
                  nombre='nombre'
                  total={this.state.checkAreaVta.length}
                  withButton
                />
                <ComboCheck
                  name='Zona'
                  idComponente={COMBO_CHECK_ZONACOMER}
                  onClickFiltrar={this.handleClickComboCheckFiltrar}
                  onClickCheck={this.handleInputChangeComboCheck}
                  lista={!this.props.zonas ? [] : this.props.zonas}
                  id='codZona'
                  nombre='desZona'
                  total={this.state.checkZonaComer.length}
                  withButton
                />
                <ComboCheck
                  name='Filial'
                  idComponente={COMBO_CHECK_FILIAL}
                  onClickFiltrar={this.handleClickComboCheckFiltrar}
                  onClickCheck={this.handleInputChangeComboCheck}
                  lista={!this.state.filialesXAreaVtaXZona ? [] : this.state.filialesXAreaVtaXZona}
                  id='id'
                  nombre='descripcion'
                  total={this.state.checkFilial.length}
                  withButton
                />
                <button
                  className='btn btn-default pageHead-filters-extra checkDeGrillaCerrar'
                  data-toggle='modal'
                  data-target='#moreFilters'
                  title='Más filtros'
                  onClick={this.abrirModalMasFiltros}
                >Más filtros</button>
                <button
                  className='btn pageHead-tableConf-clean checkDeGrillaCerrar'
                  data-toggle='tooltip'
                  data-placement='top'
                  title='Limpiar filtros'
                  data-original-title='Limpiar filtros'
                  onClick={() => this.handleClearFilter()}
                >
                  <i className='ion-funnel' />
                </button>
              </div>
            </div>
          </div>


          <div className='pageHead-rowContainer'>
            <div className='pageHead-tableConf wrapper'>
              <div  >
                <div className="fdv-tabs wrapper">
                  <div className="tabs-container">
                    <button className="tabs-left">
                      <i className="ion-chevron-left"></i>
                    </button>
                    <div className="tabs-wrapper">
                        <ul className='tabs' role='tablist'>
                                    <li className={`tabs-item ${this.state.estado === 'PR' ? 'active' : ''}`} >
                                      <a className='tabs-item-link checkDeGrillaCerrar' onClick={() => this.handleClick('PR')} >Programados</a>
                                    </li>
                                    <li className={`tabs-item ${this.state.estado === 'PP' ? 'active' : ''}`} >
                                      <a className='tabs-item-link checkDeGrillaCerrar' onClick={() => this.handleClick('PP')} >Por programar</a>
                                    </li>
                                    <li className={`tabs-item ${this.state.estado === 'PE' ? 'active' : ''} ${IDPROCESO_PCPCP ? '' : 'js-hide'}`} >
                                      <a className='tabs-item-link checkDeGrillaCerrar' onClick={() => this.handleClick('PE')} >Pendientes</a>
                                    </li>
                                    <li className={`tabs-item ${this.state.estado === 'EN' ? 'active' : ''}`} >
                                      <a className='tabs-item-link checkDeGrillaCerrar' onClick={() => this.handleClick('EN')} >Entregados</a>
                                    </li>

                                    <li className={`tabs-item ${this.state.estado === 'TO' ? 'active' : ''}`} >
                                      <a className='tabs-item-link checkDeGrillaCerrar' onClick={() => this.handleClick('TO')} >Todos</a>
                                    </li>

                                    <li className="tabs-item null" style={{display:'none'}} ><a className="tabs-item-link"> null </a></li>

                        </ul>
                    </div>
                    <button className="tabs-right">
                      <i className="ion-chevron-right"></i>
                    </button>
                  </div>
              </div>
              </div>
              <div className='pageHead-tableConf-pagCols'>
                <nav className='pag'>
                  <p className='pag-label'><span>{this.state.nInicio}</span><span> -</span><span> {this.state.nFin}</span><span> de</span><span> {this.state.totalRegistros}</span></p>
                  <div className='pag-arrows'>
                    <a className='btn btn-default pag-link checkDeGrillaCerrar' title='Anterior' onClick={this.atras} ><i className='ion-chevron-left' /></a>
                    <a className='btn btn-default pag-link checkDeGrillaCerrar' title='Siguiente' onClick={this.siguiente} ><i className='ion-chevron-right' /></a>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <div className='wrapper'>
          <div className='tab-content'>
            {this.renderTable()}
          </div>
        </div>

        <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ zIndex: '2000', display: this.state.muestraLoad }} >
          <div className='modal-dialog modal-sm' role='document'>
            <FadeLoader color={'#F8A14A'} loading />
          </div>
        </div>
        <div className='modal extraFilter' id='moreFilters' role='dialog' data-backdrop='static' style={{ display: this.state.muestraModalMasFiltros }} >
          <div className='modal-dialog modal-sm modal-pullRight' role='document'>
            <button className='btn btn-sm btn-blue modal-close' data-dismiss='modal' onClick={this.cerrarModalMasFiltros} >Cerrar ventana</button>
            <div className='modal-content'>
              <div className='modal-body'>
                <h2 className='modal-title'>Más filtros</h2>
                <div className='form-group'>
                  <label className='labelInfo'>Compañia
                  </label>
                  <ComboCheck
                    name='Compañia' idComponente={COMBO_CHECK_COMPANIA}
                    onClickCheck={this.handleInputChangeComboCheck}
                    lista={!this.props.companias ? [] : this.props.companias}
                    id='id'
                    nombre='nombre'
                    total={this.state.checkCompania.length}
                  />
                </div>
                <div className='form-group'>
                  <label className='labelInfo' htmlFor='asesorComercial' >Asesor comercial
                  </label>
                  <Autocomplete
                    inputProps={{
                      className: 'form-control awesomplete',
                      placeholder: 'Asesor Comercial',
                    }}
                    wrapperStyle={{
                      position: 'relative',
                      zIndex: '10',
                    }}
                    getItemValue={item => item.vendedor}
                    items={this.props.vendedores}
                    menuStyle={{
                      position: 'absolute',
                      left: '0',
                      top: '100%',
                      maxHeight: '350px',
                      overflow: 'auto',
                      border: '1px solid #cccccc',
                    }}
                    renderItem={(item, isHighlighted) =>
                      <div key={item.vendedor} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                        {item.descripcion}
                      </div>
                    }
                    onChange={(e) => {
                      if (e.target.value.length >= 2) {
                        this.props.fetchVendedores(e.target.value);
                      }
                      if (e.target.value.length === 0) {
                        this.props.clearVendedores();
                        this.setState({ vendedorId: '' });
                      }
                      this.setState({ vendedorName: e.target.value });
                    }}
                    value={this.state.vendedorName}
                    onSelect={(key) => {
                      this.setState({
                        vendedorName: this.props.vendedores
                                        .filter(({ vendedor }) => vendedor === key)[0].descripcion,
                        vendedorId: key,
                      });
                      this.props.clearVendedores();
                    }}
                  />
                </div>
                <div className='form-group'>
                  <label className='labelInfo'>Marca
                  </label>
                  <ComboCheck
                    name='Marca' idComponente={COMBO_CHECK_MARCA}
                    onClickCheck={this.handleInputChangeComboCheck}
                    lista={!this.props.marcas ? [] : this.props.marcas}
                    id='codMarca'
                    nombre='nomMarca'
                    total={this.state.checkMarca.length}
                  />
                </div>
                <div className='form-group'>
                  <label className='labelInfo' htmlFor='asesorComercial' >Modelo
                  </label>
                  <input
                    id='asesorComercial' value={this.state.modeloInput} onChange={(e) => { this.setState({ modeloInput: e.target.value }); }}
                    className='form-control awesomplete' data-list='Raul Enrique, Juan Perez, Ana Pareces, Bendicto, Guztavo Altor, Fabiola Manuel' required='required'
                  />
                </div>
                <div className='form-group'>
                  <label className='labelInfo' htmlFor='nomcliente' >Nombre del cliente
                  </label>
                  <input
                    id='nomcliente' value={this.state.nomClienteInput} onChange={(e) => { this.setState({ nomClienteInput: e.target.value }); }}
                    className='form-control awesomplete' data-list='Raul Enrique, Juan Perez, Ana Pareces, Bendicto, Guztavo Altor, Fabiola Manuel' required='required'
                  />
                </div>
                <div className='form-group'>
                  <label className='labelInfo' htmlFor='respEntrega' >Responsable de Entrega
                  </label>
                  <Autocomplete

                    inputProps={{
                      className: 'form-control awesomplete',
                      placeholder: 'Responsable de entrega',
                    }}
                    wrapperStyle={{
                      position: 'relative',
                      zIndex: '10',
                    }}
                    getItemValue={item => item.idUsuario.toString()}
                    items={this.props.colaboradores}
                    menuStyle={{
                      position: 'absolute',
                      left: '0',
                      top: '100%',
                      maxHeight: '350px',
                      overflow: 'auto',
                      border: '1px solid #cccccc',
                    }}

                    renderItem={(item, isHighlighted) =>
                      <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                        {`${item.apellidos} ${item.nombre}`}
                      </div>
                    }
                    onChange={(e) => {
                      if (e.target.value.length >= 2) {
                        this.props.fetchColaboradores(e.target.value);
                      }
                      if (e.target.value.length === 0) {
                        this.props.clearColaboradores();
                      }
                      this.setState({ itempersonalAd: e.target.value });
                    }}
                    value={this.state.itempersonalAd}
                    onSelect={(key) => {
                      const name = this.props.colaboradores
                      .filter(({ idUsuario }) => idUsuario.toString() === key)[0].nombre;

                      const apellidos = this.props.colaboradores
                      .filter(({ idUsuario }) => idUsuario.toString() === key)[0].apellidos;

                      console.log(key);
                        this.setState({
                         itempersonalAd: `${apellidos} ${name}`,
                         respEntrega: key,
                       });
                      this.props.clearColaboradores();
                    }}

                  />
                </div>
                <div className='form-group'>
                  <label className='labelInfo'>Familia
                  </label>
                  <ComboCheck
                    name='Familia' idComponente={COMBO_CHECK_FAMILIA}
                    onClickCheck={this.handleInputChangeComboCheck}
                    lista={!this.props.familias ? [] : this.props.familias}
                    id='codFamVeh'
                    nombre='desFamVeh'
                    total={this.state.checkFamilia.length}
                  />
                </div>
                <div className='form-group'>
                  <label className='labelInfo'>Estado pedido
                  </label>
                  <ComboCheck
                    name='Estado pedido' idComponente={COMBO_CHECK_ESTADOPED}
                    onClickCheck={this.handleInputChangeComboCheck}
                    lista={!this.props.estadoPedido ? [] : this.props.estadoPedido}
                    id='codEstadoPedido'
                    nombre='desEstadoPedido'
                    total={this.state.checkEstadoPed.length}
                  />
                </div>
                <div className='form-group'>
                  <label className='labelInfo'>Estado planificación
                  </label>
                  <ComboCheck
                    name='Estado planificación' idComponente={COMBO_CHECK_ESTADOPLAN}
                    onClickCheck={this.handleInputChangeComboCheck}
                    lista={!this.props.estadoGeneralPlanificacion ?
                            [] : this.props.estadoGeneralPlanificacion}
                    id='codTipo'
                    nombre='descripcion'
                    total={this.state.checkEstadoPlan.length}
                  />
                </div>
                <div className='form-group'>
                  <label className='labelInfo'>Estado cancelación
                  </label>
                  <ComboCheck
                    name='Estado cancelación' idComponente={COMBO_CHECK_ESTADOCANCEL}
                    onClickCheck={this.handleInputChangeComboCheck}
                    lista={!this.props.estadoCancelacion ? [] : this.props.estadoCancelacion}
                    id='codEstadoCancelacionPed'
                    nombre='desEstadoCancelacionPed'
                    total={this.state.checkEstadoCancel.length}
                  />
                </div>
                <div className='form-group'>
                  <label className='labelInfo'>Transportista
                  </label>
                  <ComboCheck
                    name='Transportista' idComponente={COMBO_CHECK_TRANSPORTISTA}
                    onClickCheck={this.handleInputChangeComboCheck}
                    lista={!this.props.estadoGeneralTransportista ?
                            [] : this.props.estadoGeneralTransportista}
                    id='codTipo'
                    nombre='descripcion'
                    total={this.state.checkTransportista.length}
                  />
                </div>
                <div className='form-group'>
                  <label className='labelInfo'>Tipo de placa
                  </label>
                  <ComboCheck
                    name='Tipo de placa' idComponente={COMBO_CHECK_TIPOPLACA}
                    onClickCheck={this.handleInputChangeComboCheck}
                    lista={!this.props.estadoGeneralTipoPlaca ?
                            [] : this.props.estadoGeneralTipoPlaca}
                    id='codTipo'
                    nombre='descripcion'
                    total={this.state.checkTipoPlaca.length}
                  />
                </div>
                <div className='form-group'>
                  <label className='labelInfo'>Tipo de entrega
                  </label>
                  <ComboCheck
                    name='Tipo de entrega' idComponente={COMBO_CHECK_TIPOENTREGA}
                    onClickCheck={this.handleInputChangeComboCheck}
                    lista={!this.props.estadoGeneralTipoEntrega ?
                            [] : this.props.estadoGeneralTipoEntrega}
                    id='codTipo'
                    nombre='descripcion'
                    total={this.state.checkTipoEntrega.length}
                  />
                </div>

                <div className='form-group'>
                  <label className='labelInfo'>Lugar de Entrega
                  </label>
                  <ComboCheck
                    name='Lugar de Entrega' idComponente={COMBO_CHECK_FILIAL_VENTA}
                    onClickCheck={this.handleInputChangeComboCheck}
                    lista={!this.state.LugarEntrega ?
                            [] : this.state.LugarEntrega}
                    id='id'
                    nombre='descripcion'
                    total={this.state.checkLugarEntrega.length}
                  />
                </div>



                <div className='row modal-actions'>
                  <div className='col-xs-12 col-sm-6'>
                    <button className='btn btn-default btn-block' data-dismiss='modal' onClick={this.cancelarModalMasFiltros} >Cancelar</button>
                  </div>
                  <div className='col-xs-12 col-sm-6'>
                    <button className='btn btn-primary btn-block' data-dismiss='modal' onClick={this.filtrarMas} >Filtrar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalProgramacion
          btnProgramar={this.state.modalavaluefrom}
          selectedID={this.state.dataRows}
          onClickmodal={this.handleChangeModalFrom}
          currentEvent={this.state.currentEvent}
          contactoCliente= {this.state.contactoCliente}
          fichasEntrega={this.props.fichasEntrega}
          programacionRow={this.state.programacionRow}
          closeModalProgramacion = {this.closeModalProgramacion}
        />

        <ModalReProgramacion

          btnProgramar={this.state.modalavalueRefrom}
          selectedID={this.state.dataRows}
          onClickmodal={this.handleChangeModalReFrom}
          dataProgramar={this.state.dataProgramar}
          datafromEntrega={this.state.datafromEntrega}
          currentEvent={this.state.currentEvent}
          FEdisponibilidad={this.state.disponibilidad}
          programacionRow={this.state.programacionRow}
          contactoCliente= {this.state.contactoCliente}
          listaMotivoReprogramacion={this.state.listaMotivoReprogramacion}

        />


        <AprobarRechazarPase
          tipo={this.state.tipoModal}
          muestraModalAprobarRechazar={this.state.muestraModalAprobarRechazar}
          cerrarModalAprobarRechazar={this.cerrarModalAprobarRechazar}
          clickAccionAprobarRechazar={this.clickAccionAprobarRechazar}
          colaboradores={this.props.colaboradores}
          traerColaboradores={this.traerColaboradores}
          limpiarColaboradores={this.limpiarColaboradores}
          ref={
            (aprobarRechazarPase) => {
              this.aprobarRechazarPase = aprobarRechazarPase;
            }}
        />
        <AnularEntregaProgramada
          muestraModalAnularEntregaProgramada={this.state.muestraModalAnularEntregaProgramada}
          programacionRow={this.state.programacionRow}
          cerrarModalAnularEntregaProgramada={this.cerrarModalAnularEntregaProgramada}
          clickAnularEntrega={this.clickAnularEntrega}
          colaboradores={this.props.colaboradores}
          traerColaboradores={this.traerColaboradores}
          limpiarColaboradores={this.limpiarColaboradores}
          estadoGeneralMotivoRechazo={this.state.motivosAnulacion}
          ref={
            (anularEntregaProgramada) => {
              this.anularEntregaProgramada = anularEntregaProgramada;
            }}
        />
        <DetalleEntregasLogistica
          muestraModalVerDetalle={this.state.muestraModalVerDetalle}
          entregasLogistica={this.props.fichasEntregaGet &&
                              this.props.fichasEntregaGet.cantidad !== 0 ?
                              this.props.fichasEntregaGet.entrega[0] : {}}
          cerrarModalVerDetalle={this.cerrarModalVerDetalle}
          historial={this.props.historial}
          clickComentar={this.clickComentar}
          colaboradores={this.props.colaboradores}
          traerColaboradores={this.traerColaboradores}
          limpiarColaboradores={this.limpiarColaboradores}
          estadoGeneralMotivoRechazo={this.state.motivosHistorial}
          personasAdicionales={this.props.Adpersonas}
          tipoProg={this.props.fichasEntregaGet &&
                              this.props.fichasEntregaGet.cantidad !== 0 ?
                              this.props.fichasEntregaGet.entrega[0].estaPlan : ''}
          ref={
            (detalleEntregasLogistica) => {
              this.detalleEntregasLogistica = detalleEntregasLogistica;
            }}
        />
        <RechazadoEntregas
          muestraModalVerRechazo={this.state.muestraModalVerRechazo}
          entregasLogistica={this.props.fichasEntregaGet &&
                              this.props.fichasEntregaGet.cantidad !== 0 ?
                              this.props.fichasEntregaGet.entrega[0] : {}}
          cerrarModalVerRechazo={this.cerrarModalVerRechazo}
          tipoProg={this.props.fichasEntregaGet &&
                              this.props.fichasEntregaGet.cantidad !== 0 ?
                              this.props.fichasEntregaGet.entrega[0].estaPlan : ''}
        />

        <div className='alert alert-warning' role='alert' id='alertFichaEntrega' style={{ display: 'none', zIndex: '2000', backgroundColor: this.state.colorBackground }}>
          <i className={this.state.iconAlert} />
          <p>{this.state.mensajeAlert}</p>
        </div>

        {
          this.handleAllOption()
        }


      </div>

    );
  }
}

function mapStateToProps(state) {
  return {
    companias: state.companias,
    familias: state.familias,
    fichasEntrega: state.fichasEntrega,
    listaEntregaLoad: state.listaload,
    marcas: state.marcas,
    estadoPedido: state.estadoPedido,
    estadoGeneralPlanificacion: state.estadoGeneralPlanificacion,
    estadoCancelacion: state.estadoCancelacion,
    estadoGeneralTransportista: state.estadoGeneralTransportista,
    estadoGeneralTipoPlaca: state.estadoGeneralTipoPlaca,
    estadoGeneralTipoEntrega: state.estadoGeneralTipoEntrega,
    fichasEntregaGet: state.fichasEntregaGet,
    areasVenta: state.areasVenta,
    zonas: state.zonas,
    colaboradores: state.colaboradores,
    estadoGeneralMotivoRechazo: state.estadoGeneralMotivoRechazo,
    historial: state.historial,
    Adpersonas: state.Adpersonas,
    indicadoresEntregas: state.indicadoresEntregas,
    listaProgramacion: state.listaProgramacion,
    vendedores: state.vendedores,

  };
}
FichaEntrega.defaultProps = {
  companias: [],
  familias: [],
  fichasEntrega: [],
  listaEntregaLoad: [],
  marcas: [],
  estadoPedido: [],
  estadoGeneralPlanificacion: [],
  estadoCancelacion: [],
  estadoGeneralTransportista: [],
  estadoGeneralTipoPlaca: [],
  estadoGeneralTipoEntrega: [],
  areasVenta: [],
  filiales: [],
  zonas: [],
  listaProgramacion: [],
  Adpersonas: [],
  listaCalendario: [],
};
export default connect(mapStateToProps, {
  fetchFamilia,
  fetchCompanias,
  fetchFichasEntrega,
  loadFichasEntrega,
  fetchFichaEntrega,
  fetchMarcasPorFamilia,
  fetchEstadoPedido,
  fetchEstadoGeneralPlanif,
  fetchEstadoCancelacion,
  fetchEstadoGeneralTransp,
  fetchEstadoGeneralTipoPlaca,
  fetchEstadoGeneralTipoEntrega,
  fetchAreasVenta,
  fetchZonas,
  fetchColaboradores,
  clearColaboradores,
  fetchEstadoGeneralMotivoRechazo,
  fetchHistorial,
  fetchIndicadoresEntregas,
  personasAdicionales,
  listarProgramacionXsede,
  fetchVendedores,
  clearVendedores,
  fetchFichasEntregaDescargar,
  fetchFamiliaPorAreaVta,
  programacionCalendario,
})(FichaEntrega);



// WEBPACK FOOTER //
// ./src/containers/FichaEntrega.js